import type { ClassDictionary } from 'classnames/types';

export type InputVariant = 'default' | 'small' | 'medium';

export const ErrorClassName = 'usa-input--error';

export function inputVariantClassNames(
  variant?: InputVariant,
  error?: boolean | string,
  success?: boolean | string,
): ClassDictionary {
  return {
    [ErrorClassName]: error,
    'usa-input--success': success,
    'usa-input--small': variant === 'small',
    'usa-input--medium': variant === 'medium',
  };
}
